import { ActionIcon, Menu } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import {
  localePath,
  MARKETING_LOCALES,
  parseLocaleFromPath,
} from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';

/**
 * URL-based language menu for the marketing site (compact icon, same pattern as the app shell).
 *
 * @param {object} [props]
 * @param {() => void} [props.onNavigate] - Called after choosing a locale (e.g. close mobile drawer)
 */
export function MarketingLanguageSwitcher({ onNavigate }) {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();
  const { pathname } = useLocation();
  const { pathWithoutLocale } = parseLocaleFromPath(pathname);

  return (
    <Menu trigger="click" position="bottom-end" withArrow shadow="md" withinPortal>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          size="lg"
          radius="md"
          aria-label={t('marketing.languageSwitcher.label')}
        >
          <IconLanguage size={22} stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {MARKETING_LOCALES.map((entry) => (
          <Menu.Item
            key={entry}
            component={Link}
            to={localePath(entry, pathWithoutLocale)}
            onClick={onNavigate}
            aria-current={entry === locale ? 'true' : undefined}
            fw={entry === locale ? 600 : undefined}
          >
            {t(`marketing.languageSwitcher.${entry}`)}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
